// React
import React from 'react';
// External
// import { Button } from 'react-bootstrap';
// Internal
import ButtonLink from 'components/shared/atoms/ButtonLink/ButtonLink';
// Styles
import './styles.scss';

/**
 * @param {string} props.title - The text to be display as title
 * @param {string} props.className - Class to be applied to the header
 * @param {string} props.style - Style to be applied to the header
 * @param {string} props.titleStyle - Style to be applied to the header text
 * @param {string} props.btnText - Text to displayed in the header button
 * @param {string} props.btnStyle - Style to be applied to the button
 */
class ContainerHeader extends React.Component {
    constructor(props) {
        super(props);
        this.className = props.className ? props.className : '';
    }

    render() {
        return (
            <div className={`container-header ${this.className}`} style={this.props.style}>
                <h3 style={this.props.titleStyle}>{this.props.title}</h3>
                {
                    this.props.to !== null && this.props.to !== undefined
                        ? (
                            <ButtonLink to={this.props.to}>
                                {this.props.btnText}
                            </ButtonLink>
                        ) : null
                }
            </div>
        );
    }
}

export default ContainerHeader;
